import React, { useState } from "react";
//  import Edittask from "./action/Edittask";

const Task = () => {
  const startDate = new Date("2025-04-07");
  const endDate = new Date("2025-04-10");
  const [showEditModal, setShowEditModal] = useState(false);

  const daysInMonth = 30;
  const taskDays = [];
  // const taskLength = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

  for (let i = 1; i <= daysInMonth; i++) {
    const current = new Date(2025, 3, i); // April is month 3 (0-based index)
    const isActive = current >= startDate && current <= endDate;
    taskDays.push({ day: i, active: isActive });
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Tasks</h2>
      <button 
        style={styles.editButton}
        onClick={() => setShowEditModal(true)}
      >
        ✏️ Edit Tasks
      </button>

      <div style={styles.taskBox}>
        <div style={styles.taskHeader}>
          <div style={styles.taskInfo}>
            <input type="checkbox" defaultChecked disabled />
            <span>Case End</span>
          </div>
          <span style={styles.taskLabel}>QUALITY CONTROL</span>
        </div>

        <div style={styles.dateGrid}>
          {taskDays.map(({ day, active }) => (
            <div
              key={day}
              style={{
                ...styles.dateCell,
                ...(active ? styles.activeDate : styles.inactiveDate),
              }}
            >
              {day}
            </div>
          ))}
        </div>

        <div style={styles.footer}>April 2025</div>
      </div>

      Edit Task Modal
      {/* <Edittask 
        showModal={showEditModal} 
        handleClose={() => setShowEditModal(false)} 
      /> */}
    </div>
  );
};

// 🔷 Blue Theme Styles
const styles = {
  container: {
    padding: "16px",
    fontFamily: "'Arial', sans-serif",
  },
  heading: {
    fontSize: "1.5rem",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#004aad",
  },
  editButton: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "8px 16px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginBottom: "10px",
    transition: "background 0.3s",
    "&:hover": {
      backgroundColor: "#0056b3",
    }
  },
  taskBox: {
    border: "1px solid #cce0ff",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 6px rgba(0, 123, 255, 0.1)",
  },
  taskHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#e9f3ff",
    padding: "10px 15px",
    fontWeight: "500",
    borderBottom: "1px solid #cce0ff",
  },
  taskInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#004aad",
  },
  taskLabel: {
    fontSize: "0.9rem",
    color: "#004aad",
  },
  dateGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(30, 1fr)",
    textAlign: "center",
    fontSize: "0.8rem",
    borderTop: "1px solid #cce0ff",
  },
  dateCell: {
    padding: "8px",
    borderRight: "1px solid #e0ecff",
  },
  activeDate: {
    backgroundColor: "#cce5ff", // Light blue for active days
    fontWeight: "bold",
    color: "#004aad",
  },
  inactiveDate: {
    backgroundColor: "#f5f9ff", // Subtle light background
    color: "#666",
  },
  footer: {
    textAlign: "right",
    fontSize: "0.9rem",
    color: "#004aad",
    padding: "5px 10px",
    backgroundColor: "#f1f7ff",
    borderTop: "1px solid #cce0ff",
  },
};

export default Task;